export const countriesConstants = {
  COUNTRIES_REQUEST: 'COUNTRIES_REQUEST',
  COUNTRIES_SUCCESS: 'COUNTRIES_SUCCESS',
  COUNTRIES_ERROR: 'COUNTRIES_ERROR',
};
